var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.isLoadingBoxes)?_c('WaitingBlock'):((_vm.boxList==null || _vm.boxList.Count==0))?_c('BoxListEmptyCard'):_c('div',[_vm._v(" Lorem Ipsum Dolor Sit Amet : page index de la section Boxes : idéal pour mettre un petit tutorial ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }